export const MAP_SCHEDULING_MODE_TITLE = {
  reschedule: 'Reschedule Delivery',
  extraDelivery: 'Schedule your extra delivery'
}
export const ID_COLLECTION_THANKSGIVING = 16
export const STORE_NY = 1
export const STORE_LA = 2
